import React from "react";
import SEO from "../components/SEO";
const Returns = () => (
  <>
    <SEO title="Return & Refund Policy" />
    <section className="max-w-3xl mx-auto px-6 py-16 text-white/80 leading-relaxed">
      <p className="font-mono-cap text-[10px] text-white/40">Policy</p>
      <h1 className="font-serif text-5xl mt-2 text-white">Returns & Refunds.</h1>
      <div className="mt-8 space-y-5 text-sm">
        <p><b className="text-white">No returns or exchanges</b> on size, fit, or change of mind — every piece is made in small batches.</p>
        <p>Returns are accepted <b className="text-white">only</b> if you receive a damaged or wrong item. Report within <b className="text-white">48 hours</b> of delivery via WhatsApp +91 8383862206 or thedripchexk@gmail.com with unboxing video and photos.</p>
        <p><b className="text-white">Refunds:</b> Once a return is approved, refunds are processed within <b className="text-white">7 business days</b> to the original payment method (UPI) or as bank transfer (for COD orders).</p>
        <p>Items must be unworn, unwashed, and with original tags intact for the return to be approved.</p>
      </div>
    </section>
  </>
);
export default Returns;
